import { useCallback, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function AlertDialogTemplate({ title, content, open, setOpen, confirmText }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default function useAlertDialog({ title, content, confirmText = "Ok" }) {
  const [open, setOpen] = useState(false);
  const [titleState, setTitle] = useState(title);
  const [contentState, setContent] = useState(content);
  const AlertDialog = useCallback(
    () => (
      <AlertDialogTemplate
        open={open}
        setOpen={setOpen}
        title={titleState}
        content={contentState}
        confirmText={confirmText}
      />
    ),
    [open, titleState, contentState, confirmText]
  );
  return {
    open,
    setOpen,
    AlertDialog,
    setTitle,
    setContent,
  };
}
